<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="box-border w-full max-w-[960px] my-0 mx-auto px-2 sm:px-4 pb-6 sm:pb-8">
      <div
        v-if="canManageTeams"
        class="flex flex-col sm:flex-row sm:justify-end sm:items-center gap-3 mb-4 sm:mb-6"
      >
        <Button
          id="btn_createTeam"
          type="button"
          icon="pi pi-plus"
          :label="$t('TeamAdministrationComponent.createNewTeam')"
          class="btn-primary-accent w-full sm:w-auto min-h-10 px-4 py-2 text-sm sm:text-base rounded-full"
          unstyled
          @click.prevent="addNewTeam"
        />
      </div>
      <div id="div_teamcontainer" class="flex flex-col gap-3 sm:gap-4 w-full">
        <single-edit-team-component
          v-for="(leadedTeam, idx) in getLeadedTeams"
          :key="leadedTeam._id != null ? leadedTeam._id : `new-team-${idx}`"
          :all-users="allUsers"
          :leaded-team="getTeamWithMappedUsers(leadedTeam)"
        />
      </div>
    </div>
  </div>
  <provide-feedback-component />
</template>

<script>
import Button from 'primevue/button';
import SingleEditTeamComponent
  from '@/components/Home/TeamAdministration/SingleEditTeamComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';
import { userIsCompanySuperuser, userIsTenantAdmin } from '@/utils/userRoles';

export default {
  name: 'TeamAdministrationComponent',
  components: {
    Button,
    SingleEditTeamComponent,
    ProvideFeedbackComponent,
  },
  computed: {
    getLeadedTeams() {
      return this.$store.state.teamManagement.tmLeadedTeams;
    },
    canManageTeams() {
      const roles = this.$store.getters.getUserRoles;
      const user = { roles };
      return userIsTenantAdmin(user) || userIsCompanySuperuser(user);
    },
    allUsers() {
      return this.$store.state.teamManagement.tmAllUsers;
    },
  },
  methods: {
    getTeamWithMappedUsers(team) {
      const leaders = [];
      const members = [];
      const generalUsers = [];
      team.leaders.forEach((e) => leaders.push(this.mapIdToUser(e)));
      team.members.forEach((e) => members.push(this.mapIdToUser(e)));
      this.allUsers.filter((e) => !team.leaders.includes(e._id))
        .forEach((e) => generalUsers.push({ ...e }));

      return {
        _id: team._id,
        name: team.name,
        leaders,
        members,
        generalUsers,
        displayTeamspace: team.displayTeamspace,
        isAdminTeam: team.isAdminTeam === true,
      };
    },
    mapIdToUser(id) {
      let user = null;
      this.allUsers.forEach((e) => {
        if (e._id === id) {
          user = { ...e };
          user.isChecked = false;
        }
      });
      return user;
    },
    addNewTeam() {
      const name = this.$t('SingleEditTeamComponent.newTeamNamePlaceholder');
      this.$store.commit('setNewTeam', name);
    },
  },
  async mounted() {
    await this.$store.dispatch('getAllUsers');
    await this.$store.dispatch('getLeadedTeams');
  },
  unmounted() {
    this.$store.commit('resetTeamManagement');
  },
};
</script>
